"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_LEGEND_CONTENT_CATEGORY_KEY = 'charting';
exports.DEFAULT_LEGEND_CONTENT_PARENT_COMPONENT_KEY = 'chartBase';
exports.DEFAULT_LEGEND_CONTENT_COMPONENT_KEY = 'defaultLegendContent';